__turbopack_context__.v({
  "appDownloadBox": "wCgASG_appDownloadBox",
  "authButtons": "wCgASG_authButtons",
  "authenticatedNav": "wCgASG_authenticatedNav",
  "closeButton": "wCgASG_closeButton",
  "container": "wCgASG_container",
  "depopLogo": "wCgASG_depopLogo",
  "footer": "wCgASG_footer",
  "getTheAppLink": "wCgASG_getTheAppLink",
  "header": "wCgASG_header",
  "headerContent": "wCgASG_headerContent",
  "logoutButton": "wCgASG_logoutButton",
  "mobileMenuWrapper": "wCgASG_mobileMenuWrapper",
  "mobileMenuWrapper--hidden": "wCgASG_mobileMenuWrapper--hidden",
  "mobileMenuWrapper--slideIn": "wCgASG_mobileMenuWrapper--slideIn",
  "mobileMenuWrapper--slideOut": "wCgASG_mobileMenuWrapper--slideOut",
  "navListItem": "wCgASG_navListItem",
  "navListItemButton": "wCgASG_navListItemButton",
  "navListItemLabel": "wCgASG_navListItemLabel",
  "offerAlertContainer": "wCgASG_offerAlertContainer",
  "offerAlertNotificationContainer": "wCgASG_offerAlertNotificationContainer",
  "offerAlertText": "wCgASG_offerAlertText",
  "primaryNav": "wCgASG_primaryNav",
  "primaryNav--showBorderBottom": "wCgASG_primaryNav--showBorderBottom",
  "primaryNav--showBorderTop": "wCgASG_primaryNav--showBorderTop",
  "secondaryNavWrapper": "wCgASG_secondaryNavWrapper",
  "selectWrapper": "wCgASG_selectWrapper",
  "socialLink": "wCgASG_socialLink",
  "socialLinks": "wCgASG_socialLinks",
});
